export var SENTRY_RELEASE = "7e4aad77bcc3f93308c64d5626b3062571342d37";
